export enum DescriptionType {
  PRODUCT = 'product',
  SHOP = 'shop'
}
export interface DescriptionProps {
  description?: string
  forceShowDescription?: boolean
  type?: DescriptionType
}
